{
  "common.close": "Zamknij",
  "common.athleteFallback": "sportowiec {id}",
  "splash.title": "{app} — animowana wizualizacja aktywności",
  "splash.tagline": "Twoje dane ze&nbsp;Stravy w ruchu",
  "splash.demo": "Demo",
  "tab.query.title": "Mapa: {name}",
  "tab.query.heading": "Zapytanie o aktywności:",
  "tab.query.optDays": "ostatnie dni",
  "tab.query.optActivities": "ostatnie aktywności",
  "tab.query.optIds": "ID aktywności",
  "tab.query.optDates": "Zakres dat",
  "tab.query.idsPlaceholder": "wpisz tutaj ID aktywności",
  "tab.query.after": "Od:",
  "tab.query.before": "Do:",
  "tab.query.autozoom": "Po imporcie automatycznie przybliż <i class=\"hf hf-bullseye\"></i> do wyników",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Pobierz",
  "tab.query.createAccount": "Załóż konto i/lub zaloguj się.",
  "tab.query.sports": "Sporty:",
  "tab.query.allSports": "Wszystkie sporty",
  "tab.query.sportsExcept": "Wszystkie oprócz",
  "tab.query.sportsNone": "Żaden",
  "tab.query.loadingSports": "Wczytywanie sportów…",
  "tab.query.sportsFailed": "Nie udało się wczytać sportów z tej mapy",
  "tab.query.noSports": "Brak aktywności",
  "tab.activities.title": "Wyświetlane aktywności",
  "tab.activities.clearSelection": "Wyczyść zaznaczenie",
  "tab.activities.renderSelected": "Wyświetl zaznaczone",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Przybliż do zaznaczenia",
  "tab.controls.title": "Ustawienia warstwy",
  "tab.controls.timescale": "Skala czasu <i>&tau;</i>",
  "tab.controls.timescaleHint": "prędkość odtwarzania",
  "tab.controls.period": "Okres <i>T</i>",
  "tab.controls.periodHint": "aktywność ~ model",
  "tab.controls.dotSize": "Rozmiar kropek",
  "tab.controls.pathWidth": "Grubość tras",
  "tab.controls.pathWidthHint": "zero ukrywa trasy",
  "tab.controls.colors": "Kolory",
  "tab.controls.colorsHint": "obróć paletę",
  "tab.controls.shadows": "Cienie",
  "tab.profile.loginTitle": "Zaloguj się",
  "tab.profile.anonNote": "Zaloguj się przez Stravę, aby zobaczyć swoje aktywności i zarządzać kontem Heatflask.",
  "tab.profile.loginLink": "Zaloguj się przez Stravę",
  "tab.profile.editOnStrava": "Edytuj profil na Stravie",
  "tab.profile.indexNote": "Indeksujemy podsumowania Twoich aktywności, aby mieć do nich szybki dostęp.",
  "tab.profile.viewIndex": "Zobacz indeks",
  "tab.profile.sharedMaps": "Udostępnione mapy",
  "tab.profile.sharedMapsNote": "Wyłączone: tylko Ty widzisz swoje aktywności w Heatflask. Włączone: każdy, kto ma link do Twojej mapy, zobaczy Twoje publiczne aktywności ze Stravy. Prywatne w każdym przypadku pozostają tylko Twoje. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Jak działa prywatność</a>",
  "tab.profile.logout": "Wyloguj się",
  "tab.profile.deleteAccount": "Usuń konto",
  "tab.profile.deleteConfirm": "Usunąć konto Heatflask?\n\nSpowoduje to usunięcie zindeksowanych aktywności i odebranie Heatflask dostępu do Twoich danych ze Stravy. Tej operacji nie można cofnąć.",
  "tab.profile.languageHeading": "Język",
  "tab.profile.languageAuto": "Automatycznie",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Pomóż nam poprawić tłumaczenia lub dodać nowe!</a>",
  "tab.profile.unitsHeading": "Jednostki",
  "tab.profile.unitsAuto": "Automatycznie",
  "tab.profile.unitsMetric": "Metryczne (km, m)",
  "tab.profile.unitsImperial": "Imperialne (mi, ft)",
  "tab.profile.textSizeHeading": "Rozmiar tekstu",
  "tab.profile.textSmaller": "Mniejszy",
  "tab.profile.textReset": "Normalny",
  "tab.profile.textLarger": "Większy",
  "tab.profile.mapDefaultsHeading": "Domyślne ustawienia mapy",
  "tab.profile.mapDefaultsNote": "Zaczynaj od tej mapy bazowej, rzeźby terenu i ustawień warstwy, gdy otwierasz mapę, której link nie ustala własnych. Udostępniane linki nadal pokazują dokładnie to, co widzisz.",
  "tab.profile.mapDefaultsSave": "Zapisz jako moje domyślne",
  "tab.profile.mapDefaultsForget": "Zapomnij",
  "tab.info.title": "Informacje",
  "tab.info.controlsHeading": "Sterowanie",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + przeciągnij",
  "tab.info.shiftDragDesc": "Zaznacz aktywności prostokątem. Na ekranie dotykowym najpierw dotknij <i class=\"hf-object-group\"></i>, a potem przeciągnij jednym palcem. Ostatnia zaznaczona aktywność pokazuje swoje szczegóły, a lista aktywności przewija się do niej.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + przeciągnij",
  "tab.info.ctrlDragDesc": "Obracaj i pochylaj mapę w 3D albo użyj dwóch palców",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Otwórz lub zamknij panel boczny",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Poprzednia lub następna karta panelu",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Zamknij panel boczny",
  "tab.info.liveUrlHeading": "Adres URL na żywo",
  "tab.info.liveUrlDesc": "Widok mapy i ustawienia animacji są zapisane w adresie URL strony, więc każdy, komu go udostępnisz, zobaczy ten sam widok.",
  "tab.info.videoHeading": "Eksport wideo",
  "tab.info.videoDesc": "Przycisk <i class=\"hf-video-camera\"></i> nagrywa animację jako MP4: dotknij go, ustaw ramkę nad wybranym fragmentem mapy i dotknij ponownie, aby nagrać. Nagrywana jest jedna pełna pętla animacji, więc wideo zapętla się płynnie; pętla dłuższa niż {max} s (najdłuższe wideo, jakie przyjmuje Strava) zostaje ucięta po {max} s.",
  "tab.info.contributeHeading": "Współpraca",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Wesprzyj na GitHubie",
  "tab.info.contactsHeading": "Kontakt",
  "map.basemapAndTerrain": "Mapa podkładowa i teren",
  "map.pauseAnimation": "Wstrzymaj animację",
  "map.resumeAnimation": "Wznów animację",
  "capture.record": "Nagraj wideo (pętla {period} s)",
  "capture.recordTruncated": "Nagraj wideo (jeden cykl trwa {period} s; nagranych zostanie tylko pierwszych {max} s)",
  "capture.recordArea": "Nagraj obszar wewnątrz ramki",
  "capture.stop": "Zatrzymaj nagrywanie",
  "capture.selectionTooSmall": "zaznaczenie jest za małe",
  "capture.saved": "zapisano {name} ({size})",
  "capture.cancelled": "nagrywanie anulowane",
  "capture.failed": "nagrywanie nie powiodło się: {error}",
  "capture.loadingEncoder": "ładowanie kodera…",
  "capture.waitingForMap": "czekam na załadowanie mapy…",
  "capture.encoding": "kodowanie… {percent}%",
  "capture.finalizing": "kończenie…",
  "share.title": "Udostępnij link do tej mapy",
  "share.copied": "link skopiowany",
  "share.copiedUnshared": "link skopiowany — ale twoja mapa nie jest udostępniona, więc nikt inny jej nie otworzy. Włącz „Udostępnione mapy”, aby to zmienić.",
  "share.unshared": "Twoja mapa nie jest udostępniona, więc nikt inny nie otworzy tego linku. Włącz „Udostępnione mapy”, aby to zmienić.",
  "share.copyThis": "Skopiuj ten link:",
  "update.available": "Dostępna jest nowa wersja Heatflask.",
  "update.reload": "Odśwież",
  "import.title": "Importowanie",
  "import.stop": "Zatrzymaj",
  "import.stopping": "zatrzymywanie…",
  "import.contacting": "łączenie ze Stravą…",
  "import.countOf": "{received} z {total} aktywności",
  "import.count": "Aktywności: {received}",
  "import.waitStrava": "Wstrzymano do {time} przez limit pobierania Stravy. Zostaw tę stronę otwartą; odświeżanie nie przyspieszy.",
  "import.waitRationed": "Dzisiejsze szybkie pobieranie zostało wykorzystane. Reszta ruszy o {time}, wolniej. Zostaw tę stronę otwartą.",
  "import.dailyLimit": "Dzienny limit pobierania Stravy został wyczerpany. Spróbuj ponownie po {time}.",
  "import.dailyRationed": "Twój dzisiejszy przydział pobrań ze Stravy został wykorzystany. Spróbuj ponownie po {time}.",
  "import.noActivitiesYet": "Twoje konto Strava nie ma jeszcze żadnych aktywności. Zarejestruj lub prześlij jedną na Stravie, a pojawi się tutaj.",
  "table.noActivities": "brak aktywności",
  "table.untitled": "(bez tytułu)",
  "activities.pageTitle": "{app} — Indeks aktywności",
  "activities.heading": "Indeks aktywności",
  "activities.fetching": "Pobieranie aktywności...",
  "activities.rateLimit": "Osiągnięto limit zapytań Stravy; wznowienie o {time}",
  "activities.noData": "Niestety brak danych &#128577;",
  "activities.colServerCache": "Trasa w pamięci podręcznej serwera (Mongo)",
  "activities.colBrowserCache": "Trasa w pamięci podręcznej tej przeglądarki",
  "activities.cachedServer": "Trasa {id} jest w pamięci podręcznej serwera",
  "activities.notCachedServer": "Trasy {id} nie ma w pamięci podręcznej serwera",
  "activities.cachedBrowser": "Trasa {id} jest w pamięci podręcznej tej przeglądarki",
  "activities.notCachedBrowser": "Trasy {id} nie ma w pamięci podręcznej tej przeglądarki",
  "sport.AlpineSki": "Narciarstwo zjazdowe",
  "sport.BackcountrySki": "Skitury",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Koszykówka",
  "sport.Canoeing": "Kajak kanadyjski",
  "sport.Cricket": "Krykiet",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Taniec",
  "sport.EBikeRide": "Jazda na e-rowerze",
  "sport.Elliptical": "Orbitrek",
  "sport.EMountainBikeRide": "Jazda na e-MTB",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Jazda gravelowa",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Wędrówka",
  "sport.IceSkate": "Łyżwiarstwo",
  "sport.InlineSkate": "Rolki",
  "sport.Kayaking": "Kajakarstwo",
  "sport.Kitesurf": "Kitesurfing",
  "sport.MountainBikeRide": "Jazda na MTB",
  "sport.NordicSki": "Narciarstwo biegowe",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fizjoterapia",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Jazda na rowerze",
  "sport.RockClimbing": "Wspinaczka",
  "sport.RollerSki": "Nartorolki",
  "sport.Rowing": "Wioślarstwo",
  "sport.Run": "Bieg",
  "sport.Sail": "Żeglarstwo",
  "sport.Skateboard": "Deskorolka",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Rakiety śnieżne",
  "sport.Soccer": "Piłka nożna",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "Stand up paddle",
  "sport.Surfing": "Surfing",
  "sport.Swim": "Pływanie",
  "sport.TableTennis": "Tenis stołowy",
  "sport.Tennis": "Tenis",
  "sport.TrailRun": "Bieg terenowy",
  "sport.Velomobile": "Welomobil",
  "sport.VirtualRide": "Wirtualna jazda na rowerze",
  "sport.VirtualRow": "Wirtualne wiosłowanie",
  "sport.VirtualRun": "Wirtualny bieg",
  "sport.Volleyball": "Siatkówka",
  "sport.Walk": "Spacer",
  "sport.WeightTraining": "Trening siłowy",
  "sport.Wheelchair": "Wózek inwalidzki",
  "sport.Windsurf": "Windsurfing",
  "sport.Workout": "Trening",
  "sport.Yoga": "Joga"
}
